'use client';

import React from 'react';

import { Stack, Heading, Flex, Box } from '@chakra-ui/react';
import Link from 'next/link';

import { CustomText } from '@components/Custom-text';
import { UserType } from '@enums/index';
import { paths } from '@routes/path';

import AuthFooter from '../../common/components/AuthFooter';
import useLogin from '../../hooks/useLogin';
import LoginForm from '../forms/LoginForm';

interface LoginProps {
    userType: UserType;
}

const Login = ({ userType }: LoginProps) => {
    const { handleLogin, isLoading } = useLogin({ userType });
    return (
        <Flex
            minWidth="100%"
            justifyContent="center"
            flexDirection="column"
            position="relative"
            minHeight="100vh"
        >
            <Stack spacing={8} width="100%" justifyContent="center">
                <Stack width="100%" alignItems="center">
                    <Heading size="xl" color="titleText">
                        Welcome {userType === UserType.Mentee ? 'Mentee' : 'Mentor'}
                    </Heading>
                    <CustomText color="subText" paddingLeft={4}>
                        Enter your login details below
                    </CustomText>
                </Stack>
                <Box>
                    <LoginForm
                        onSubmit={values => handleLogin(values)}
                        isLoading={isLoading}
                        userType={userType}
                    />
                    <Stack mt={10} width="100%" alignItems="center">
                        <Flex columnGap={1}>
                            <CustomText color="titleText">
                                Don’t have a {userType === UserType.Mentee ? 'Mentee' : 'Mentor'}{' '}
                                account?
                            </CustomText>
                            <Link
                                  href={userType === UserType.Mentee 
                                    ? paths.mentee.auth.signup 
                                    : paths.mentor.auth.signup}
                            >
                                <CustomText weight={500} color="primary.light">
                                    Sign up
                                </CustomText>
                            </Link>
                        </Flex>
                        <Flex columnGap={1}>
                            <CustomText color="titleText">
                                Not a {userType === UserType.Mentee ? 'Mentee' : 'Mentor'}?
                            </CustomText>
                            <Link
                                href={
                                    userType === UserType.Mentee
                                        ? paths.mentor.auth.login
                                        : paths.mentee.auth.login
                                }
                            >
                                <CustomText weight={500} color="primary.light">
                                    Sign In
                                </CustomText>
                            </Link>

                            <CustomText color="titleText">
                                as a {userType === UserType.Mentee ? 'Mentor' : 'Mentee'}
                            </CustomText>
                        </Flex>
                    </Stack>
                </Box>
            </Stack>
            <AuthFooter />
        </Flex>
    );
};

export default Login;
